import { Heading, Text } from '@aws-amplify/ui-react';

export default function Instructions() {
  return (
    <main>
      <Heading level={4} style={{marginBottom: "0.5em"}}>Asset Validation</Heading>
      <Text style={{marginBottom: "1em"}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</Text>
    </main>
  )
}